import React, { useEffect, useState, useMemo } from "react";
import CustomButton from "../../../AppComponent/CustomButton/CustomButton";
import { useDispatch, useSelector } from "react-redux";
import {
    getSideBarfilesActions,
    settheTicketSubQuestionActions,
    setTheTicketSUbQuestionsDeleteActions, ///delete
    setTheTicketSubQuestionsEditionsActions,
    setheticketsubcategoryactions
} from "../../../../Redux/Slice";
import { NavLink } from "react-router-dom";
import ReactTable from "../../../AppComponent/Table";
import Select from "react-select";
import Delete from "../../../AppComponent/Popup/Delete";
import Search from "@mui/icons-material/Search";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import BackImage from "../../../../Assets/AppComponent/Overall_icons/UDS Needs Image-20.svg";
import DeleteImages from "../../../../Assets/AppComponent/Overall_icons/UDS Needs Image-05.svg";
import EditImages from "../../../../Assets/AppComponent/Overall_icons/UDS Needs Image-04 (1).svg";
import SubCategoriesCrud from "./SubCategoriesCrud";


const SubCategorylits = () => {
    const dispatch = useDispatch();
    const stateDisplay = useSelector(
        (state) => state.SideBarActive.SidebarActive
    );

    const navigate = useNavigate();
    const state = useSelector((state) => state);
    const [RoleCreatePopup, setRoleCreatePopup] = useState(false);
    const [newpages, setNewpage] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [dtpageindex, setdtPageindex] = useState(1);
    const [dtpagesize, setdtPagesize] = useState(10);
    const [search, setsearch] = useState("");
    const [pageSize, setPageSize] = useState(20);
    const [DeletePOPUP, setDeletePOPUP] = useState(false);
    const [DeleteID, setDeleteID] = useState("");
    const [EditId, setEditID] = useState();

    const [ParentId, setParentid] = useState(state.NeededdatasListed.SubQueryIDs);
    const [ActiveContent, setActiveContent] = useState({
        is_active: true,
        id: "",
    })
    const [activepopup, setactivePopup] = useState(false)
    const [AllEmp, setALlEMp] = useState(
        //   {
        //   label: "ALL",
        //   value: false,
        // }
        state.StateManagementOverallCall.ticketsystemSubcategoryActive
    );
    const optionsforfilter = [
        {
            label: "ALL",
            value: "",
        },
        {
            label: "Active",
            value: true,
        },
        {
            label: "In active",
            value: false,
        },

    ];
    const [Activest, setactivest] = useState(state.StateManagementOverallCall.ticketsystemSubcategoryActive?.value)
    const handlechangescompletd = (e) => {
        setALlEMp(e)
        dispatch(setheticketsubcategoryactions(e));
        setactivest(e.value);
    };


    useEffect(() => {
        const payload = {
            search: search,
            page_size: 20,
            page: dtpageindex,
            category: state.NeededdatasListed.SubQueryIDs,
            active: Activest
        };
        dispatch(settheTicketSubQuestionActions(payload));
    }, [dtpageindex, search, Activest]);

    const debouncedSearch = useMemo(
        () =>
            _.debounce((e) => {
                setsearch(e)
            }, 500),
        []
    );

    function tochange(e) {
        setsearch(e);
        debouncedSearch(e);

    }

    React.useEffect(() => {
        return () => {
            debouncedSearch.cancel();
        };
    }, [debouncedSearch]);

    const pagesize = (arg) => {
        setdtPagesize(arg);
    };
    const pageindex = (arg) => {
        //  console.log(arg, "args");
        setdtPageindex(arg);
    };



    const truncateText = (text, maxLength) => {
        if (text.length <= maxLength) {
            return text;
        }
        return text.substring(0, maxLength) + "...";
    };

    const formatedDateListwithouttime = (dateString) => {
        const date = new Date(dateString);

        // Options for date formatting (only date)
        const dateOptions = {
            month: "short", // e.g., Dec
            day: "2-digit", // e.g., 22
            year: "numeric", // e.g., 2024
        };

        // Options for time formatting (only time)
        const timeOptions = {
            hour: "2-digit", // e.g., 02
            minute: "2-digit", // e.g., 16
            hour12: true, // e.g., AM/PM format
        };

        // Format the date and time separately
        const formattedDate = date.toLocaleDateString("en-US", dateOptions);
        const formattedTime = date.toLocaleTimeString("en-US", timeOptions);

        // Combine the formatted date and time
        return `${formattedDate}`;
    };



    const columns = [
        {
            Header: "Subcategory",
            accessor: "",
            Cell: (row) => {
                return (
                    <>
                        {row.row.original.name ? (
                            <span>{truncateText(row.row.original.name , 30)}</span>
                        ) : (
                            <span>---</span>
                        )}
                    </>
                );
            },
        },

        {
            Header: "Created Date",
            accessor: "",
            Cell: (row) => {
                const dateString = row.row.original.created_at;
                const dateObject = new Date(dateString);
                const hours = dateObject.getHours();
                const minutes = dateObject.getMinutes();
                const seconds = dateObject.getSeconds();
                const amOrPm = hours >= 12 ? "PM" : "AM";
                const twelveHourFormat = hours % 12 || 12;
                const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

                const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

                return (
                    <>
                        <span>
                        {row.row.original.created_at ? formatedDateListwithouttime(row.row.original.created_at)
                                : ""
                            }
                            {/* {`${row.row.original.created_at.sli////ce(0, 10)}`} */}
                        </span>
                    </>
                );
            },
            // sortType: (a, b) => {
            //     const dateA = new Date(a);
            //     const dateB = new Date(b);
            //     if (isNaN(dateA.getTime())) return 1;
            //     if (isNaN(dateB.getTime())) return -1;
            //     return dateA.getTime() - dateB.getTime();
            // }
            // disableSortBy: false, 


        },

        // {
        //     Header: "TAT",
        //     accessor: "",
        //     Cell: (row) => {
        //         return (
        //             <>
        //                 {row.row.original.TAT ? (
        //                     <div>
        //                         {row.row.original.TAT}</div>
        //                 ) : (
        //                     <div>---</div>
        //                 )}
        //             </>
        //         );
        //     },
        // },
        {
            Header: "Description",
            accessor: "",
            Cell: (row) => {
                return (
                    <>
                        {row.row.original.description ? (
                            <span>{truncateText(row.row.original.description , 30)}</span>
                        ) : (
                            <span>---</span>
                        )}
                    </>
                );
            },
        },


        {
            Header: "Active",
            accessor: "",
            Cell: (row) => {
                return (
                    <>
                        {row.row.original.is_active ? (
                            <span>{row.row.original.is_active ?
                                "YES" :
                                "NO"
                            }</span>
                        ) : (
                            <span>---</span>
                        )}
                    </>
                );
            },
        },


        // {
        //     Header: "Priority",
        //     accessor: "",
        //     Cell: (row) => {
        //         const priority = row.original.Priority != null && row.original.Priority != undefined ?
        //         row.original.Priority :"";


        //         const styles = {
        //             background: priority === "0" 
        //                 ? "#FDEDE9" 
        //                 : priority === "1" 
        //                 ? "#FFF8E5" 
        //                 : priority === "2" 
        //                 ? "#E7F8ED" 
        //                 : "#F0F0F0", // Default background for no priority
        //             color: priority === "0" 
        //                 ? "#ED4C28" 
        //                 : priority === "1" 
        //                 ? "#FFB800" 
        //                 : priority === "2" 
        //                 ? "#12B749" 
        //                 : "#333", // Default text color
        //             padding: "5px 10px",
        //             borderRadius: "5px",
        //             display: "inline-block",
        //             textAlign: "center",
        //         };  
        //         return (
        //             <>
        //                 {/* {row.row.original.Priority ? (
        //                     <span>{row.row.original.Priority == "0" ?

        //                         "Low" : row.row.original.Priority == "1" ?
        //                             "Medium" : "High"
        //                     }</span>
        //                 ) : (
        //                     <span>---</span>
        //                 )} */}
        //                             <span style={styles}>
        //         {priority === "0"
        //             ? "Low"
        //             : priority === "1"
        //             ? "Medium"
        //             : priority === "2"
        //             ? "High"
        //             : "---"}
        //     </span>

        //             </>
        //         );
        //     },
        // },
        {
            Header: "Priority",
            accessor: "",
            Cell: ({ row }) => {
                // Safely handle undefined or null values
                const priority = row.original?.Priority || "";

                // const styles = {
                //     background: priority === "0"
                //         ? "#FDEDE9"
                //         : priority === "1"
                //         ? "#E7F8ED"
                //         : priority === "2"
                //         ? "#FDEDE9" 
                //         : "transparent", // Default background for no priority
                //     color: priority === "0"
                //         ? "#ED4C28"
                //         : priority === "1"
                //         ? "#FFB800"
                //         : priority === "2"
                //         ? "#FDEDE9"
                //         : "#333", // Default text color
                //     padding: "5px 10px",
                //     borderRadius: "5px",
                //     display: "inline-block",
                //     textAlign: "center",
                // };
                const styles = {
                    background: priority === "0" // High Priority
                        ? "#FDEDE9" // Light red background
                        : priority === "1" // Medium Priority
                            ? "#FDEDE9" // Light red background
                            : priority === "2" // Low Priority
                                ? "#FDEDE9" // Light red background
                                : "transparent", // Default background for no priority
                    color: priority === "0" // High Priority
                        ? "#ED4C28" // Red text
                        : priority === "1" // Medium Priority
                            ? "#ED4C28" // Red text (light red perception)
                            : priority === "2" // Low Priority
                                ? "#ED4C28" // Red text (light red perception)
                                : "#333", // Default text color
                    padding: "5px 10px",
                    borderRadius: "5px",
                    display: "inline-block",
                    textAlign: "center",
                    width: "95px"
                };

                return (
                    <span style={styles}>
                        {priority === "0"
                            ? "Low"
                            : priority === "1"
                                ? "Medium"
                                : priority === "2"
                                    ? "High"
                                    : "---"}
                    </span>
                );
            },
        },
        // {
        //     Header: "Active & Inactive",
        //     accessor: "isActive", // Ensure this corresponds to the correct property in your data
        //     Cell: ({ cell }) => {
        //         const data = cell.row.original;

        //         const handleToggle = (e) => {
        //             const newStatus = e.target.checked;
        //             console.log(`Toggled status for ID ${data.id}: ${newStatus}`);
        //             HandleActions(newStatus, data); // Pass new status and data to your action handler
        //         };

        //         return (
        //             <div className="listActionCell">
        //                 <label className="switch" onClick={(e) => {
        //                     e.stopPropagation();

        //                 }}>
        //                     <input
        //                         type="checkbox"
        //                         checked={data.is_active} // Assuming `isActive` indicates active status
        //                         onChange={(e) => {
        //                             e.stopPropagation();
        //                             handleToggle(e)
        //                         }}
        //                     />
        //                     <span className="slider round"></span>
        //                 </label>
        //             </div>
        //         );
        //     },
        // },

        {
            Header: "Actions",
            accessor: "",
            Cell: (row) => {
                return (
                    <>
                        {row.row.original != undefined &&
                            row.row.original.id != undefined &&
                            row.row.original.issue_category_id != undefined &&
                            row.row.original.issue_category_id != undefined ? (
                            <div
                                class="actions"
                                style={{
                                    display: "flex",
                                    justifyContent: "flex-start",
                                    gap: "5px",
                                }}
                            >
                                <button
                                    className=" btn Status"
                                    onClick={(e) => {
                                        setParentid(row.row.original.issue_category_id);
                                        setEditID(row.row.original.id);
                                        setRoleCreatePopup(true);
                                    }}
                                    component="span"
                                >
                                    <span className="OuterActionSpan">

                                        <span className="EditImages">
                                            <img src={EditImages} />
                                        </span>
                                        <span className="ActionsList"> Edit </span>
                                    </span>
                                </button>

                                <button
                                    type="button"
                                    class="btn Status"
                                    onClick={(e) => {
                                        setDeleteID(row.row.original.id);
                                        setDeletePOPUP(true);
                                    }}
                                >
                                    <span className="OuterActionSpan">

                                        <span className="EditImages">
                                            <img src={DeleteImages} />
                                        </span>

                                        <span className="ActionsList"> Delete </span>
                                    </span>
                                </button>
                            </div>
                        ) : null}
                    </>
                );
            },
        },
    ];

    const HandleActions = (newdatas, data) => {
        console.log(newdatas, data, "asdasduaspdoiasd ");
        setActiveContent({
            ...ActiveContent,
            is_active: newdatas,
            id: data.id
        })
        setactivePopup(true)
    }

    const HandleActives = () => {
        const payload = {
            currentPage: dtpageindex,
            EditID: ActiveContent.id,
            search: search,
            Rawdata: {
                is_active: ActiveContent.is_active,
            }
        }
        dispatch(setTheTicketSubQuestionsEditionsActions(payload, setactivePopup(false)));

    }


    const HandleDeletes = () => {
        if (DeleteID != undefined) {
            console.log(currentPage, "sdsd");
            const payload = {
                DeleteId: DeleteID,
                currentPage: dtpageindex,
                category: state.NeededdatasListed.SubQueryIDs,
            };
            dispatch(
                setTheTicketSUbQuestionsDeleteActions(payload, setDeletePOPUP(false))
            );
        }
    };

    const handleNext = (next) => {
        setdtPageindex(next + 1);
    };

    const GotoEnteredPage = (gotopage) => {
        setdtPageindex(gotopage)
    }

    const handlePrevious = (previous) => {
        if (previous != 0) {
            setdtPageindex(previous);

        }
    };

     
    return (
        <>
            <div className={stateDisplay ? "outterContent" : "inner-Content"}>
                <div
                    className="Header-Details ClientBranch row"
                    style={{ padding: "14px 28px" }}
                >
                    <div
                        class="col-sm-7 auto"
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            justifyContent: "flex-start",
                        }}
                    >
                        <h3>Subcategory </h3>

                    </div>
                    <div className="createticketing col-sm-5">
                        <button
                            style={{ zIndex: "555" }}
                            onClick={(e) => {
                                setRoleCreatePopup(true);
                                setEditID("");
                            }}
                            className="Createbutton"
                        >
                            {" "}
                            {/* Create Ticket */}
                            Create
                        </button>
                    </div>
                </div>

                <div
                    className="row Filters ButtonPrevious"
                    style={{
                        padding: "15px 28px",
                        margin: "0px",
                        position: "relative",
                        zIndex: "30",

                        marginLeft: "0px",
                        marginRight: "0px",
                        top: "-30px",
                    }}
                >
                    <div className="col">
                        <button
                            className="btn BackImga"
                            onClick={(e) => {
                                navigate("/ticket_category");
                            }}
                        >
                            <img className="PreviousPages" src={BackImage} />
                            <span></span>
                        </button>
                    </div>
                </div>

                <div style={{ padding: " 0px 40px", marginTop: "-13px" }}>
                    <ReactTable
                        data={state.TicketSubQuetionsDatas.TicketQuestionsDatas}
                        columns={columns}
                        totalItems={state.TicketSubQuetionsDatas.Total_Count}
                        currentPage={currentPage}
                        onChange={tochange}
                        setCurrentPage={setCurrentPage}
                        pagesize={pagesize}
                        dtpagesize={pageSize}
                        dtpageindex={dtpageindex}
                        pageindex={pageindex}
                        onPrevious={handlePrevious}
                        onNextpage={handleNext}
                        GotoEnteredPage={GotoEnteredPage}
                        datacount={state.TicketSubQuetionsDatas.Total_Count}
                        Filter={true}
                        // NoFilter={true}

                        AppSideView={true}
                        iscompletedLabel="Status"
                        AllEmp={AllEmp}
                        handlechangescompletd={handlechangescompletd}
                        optionsforfilter={optionsforfilter}
                        nostatusFilter={true}


                    />
                </div>
            </div>


            {DeletePOPUP ? (
                <Delete
                    show={DeletePOPUP}
                    setShow={setDeletePOPUP}
                    onSubmit={HandleDeletes}
                    Content={"Do you want to delete the Subcategory"}

                />
            ) : null}


            {RoleCreatePopup && EditId == "" ? (
                <SubCategoriesCrud
                    setShow={setRoleCreatePopup}
                    show={RoleCreatePopup}
                    currentPage={dtpageindex}
                    EditID={EditId}
                    ParentId={ParentId}
                    search={search}
                />
            ) : null}

            {RoleCreatePopup && EditId != "" ? (
                <SubCategoriesCrud
                    setShow={setRoleCreatePopup}
                    show={RoleCreatePopup}
                    currentPage={dtpageindex}
                    EditID={EditId}
                    search={search}
                    ParentId={ParentId}
                />
            ) : null}


            {activepopup &&

                <div className='DeletePopUp'>
                    <div className='DeleteClose'>
                        <div className='DeleteOutter'>
                            <div className='DeleteText'>
                                <p>DO YOU WANT TO {ActiveContent.is_active === true ? "ACTIVE" : "INACTIVE"} THE ORGANIZATION?</p>
                            </div>
                            <div className='DeleteButton'>
                                <button className='DeleteCancel' onClick={() => {
                                    setactivePopup(false);
                                }}>Cancel</button>
                                <button className='DeleteSave' onClick={(e) => { HandleActives() }}>Yes</button>
                            </div>
                        </div>
                    </div>
                </div>

            }
        </>



    );
};

export default SubCategorylits;
